'use strict';

angular.module('theme').directive('loading', function () {
	return {
		restrict: 'E',
		templateUrl: 'component/loading.html',
		scope: {
			loading: '='
		}
	};
});
